$(() => {
    $(document).on('click', '#login_validation_form button', function (e) {
        e.preventDefault();

        const $form = $('#login_validation_form');

        if ($form.parsley().validate() === false) {
            return false;
        }

        $('#login_validation_form input').attr('readonly', true);
        $('#login_validation_form button').attr('disabled', true);
        $form.submit();
    });
    $(document).on('keypress', '#login_validation_form input', function (e) {
        const isEnterKey = e.which === 13;
        if (isEnterKey) {
            $('#login_validation_form button').click();
            return false;
        }
    });
});
